import { schema } from 'normalizr';

const MUNICIPALITY_SCHEMA = new schema.Entity('municipalities', {}, { idAttribute: '@id' });

export default {
  Municipality: MUNICIPALITY_SCHEMA
};
